import Tooltip from 'antd/lib/tooltip';
import 'antd/lib/tooltip/style/index.css';

export default Tooltip;
